module.exports = {
    couplingTypes: [{key:"rigid",name:"Rigid"},{key:"flexible",name:"Flexible"}],
    rigids: [
        {key:"flangeCouplings",name:"Flange Couplings"},
        {key:"sleeve/MuffCouplings",name:"Sleeve / Muff Couplings"},
        {key:"sleeveCouplingWithTaperPins",name:"Sleeve Couplings With Taper Pins"},
        {key:"clamp/Ribbed/SplitMuff/CompressionCouplings",name:"Clamp / Ribbed / Split Muff / Compression Couplings"},
        {key:"ringCompressionCouplings",name:"Ring Compression Couplings"},
        {key:"setScrewCouplings",name:"Set Screw Couplings"},
        {key:"splineCouplings",name:"Spline Couplings"}
    ],
    flexibles: [{key:"mechanical",name:"Mechanical"}, {key:"elastomeric",name:"elastomeric"}, {key:"membrane",name:"Membrane"}],
    mechanicals: [{key:"gearType",name:"Gear Type"},{key:"universalJoint",name:"Universal Joint"}, {key:"springGrid",name:"Spring Grid"}],
    elastomerics: [
        {key:"elastomerInTyre",name:"Elastomer in Tyre"},
        {key:"elastomerInJaw",name:"Elastomer in Jaw"},
        {key:"elastomerInSplineSleeve",name:"Elastomer in Spline Sleeve"},
        {key:"elastomerInShearJaw",name:"Elastomer in Shear Jaw"},
        {key:"spacerType",name:"Spacer Type"},
        {key:"pinAndBush",name:"Pin and Bush"},
        {key:"rubberBlock",name:"Rubber Block"},
    ],
    membranes: [{key:"multipleDiscCoupling",name:"Multiple Disc Coupling"}, {key:"diaphragmCoupling",name:"Diaphragm Coupling"}]
}
